<template>
    <b-modal
        id="modal-payfromcheeseitdemo"
        size=""
        :title="$t('com_paymentprovider', { ns: 'common' })"
        :visible="visible"
        no-close-on-backdrop
        hide-header-close
        @cancel="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-card
            v-bind:class="{
                loadingstate: spinnervisible,
                loading: spinnervisible
            }"
        >
            <h5>{{ this.selectedSiteFormatted }}</h5>
            <div v-if="this.failureMessage" class="alert alert-warning">
                <strong>{{ $t('com_paymentfailed', { ns: 'common' }) }}</strong>
                {{ this.failureMessage }}
            </div>

            <div v-if="missingFields.length > 0" class="alert alert-danger">
                {{ $t('com_fillfields', { ns: 'common' }) }}
                <ul>
                    <li v-for="field in missingFields" :key="field">
                        {{
                            field === 'name'
                                ? $t('com_naam', { ns: 'common' })
                                : field === 'email'
                                ? $t('com_mail', { ns: 'common' })
                                : field === 'locale'
                                ? $t('com_language', { ns: 'common' })
                                : field
                        }}
                    </li>
                </ul>
            </div>
            <div>
                
                <br />
                {{ $t('com_customerdetails', { ns: 'common' }) }}:
                <b-form-group>
                    {{ $t('com_naam', { ns: 'common' }) }}:
                    <b-form-input
                        v-model="startSubscriptionModel.customer.name"
                        placeholder="John Doe"
                        :readonly="knownCustomer"
                    ></b-form-input>
                    {{ $t('com_mail', { ns: 'common' }) }}:
                    <b-form-input
                        v-model="startSubscriptionModel.customer.email"
                        placeholder="j.doe@example.com"
                        :readonly="knownCustomer"
                    ></b-form-input>
                    {{ $t('com_language', { ns: 'common' }) }}:
                    <b-form-select
                        v-model="startSubscriptionModel.customer.locale"
                        :disabled="knownCustomer"
                    >
                        <b-form-select-option value="nl_NL"
                            >Nederlands</b-form-select-option
                        >
                        <b-form-select-option value="en_US"
                            >English</b-form-select-option
                        >
                        <b-form-select-option value="de_DE"
                            >Deutsch</b-form-select-option
                        >
                        <b-form-select-option value="es_ES"
                            >Español</b-form-select-option
                        >
                    </b-form-select>
                </b-form-group>
                <b-button
                    variant="secondary"
                    @click="enableCustomerEdit"
                    v-if="knownCustomer"
                >{{
                $t('com_change', {
                    ns: 'common',
                    val: $t('com_customerdetails', { ns: 'common' }).toLowerCase()
                })}}
                </b-button>
            </div>
            <div v-if="hasActiveSubscription">
                <br />
                <div class="alert alert-success">
                {{ $t('com_yourcurrent', {
                    ns: 'common',
                    val: $t('com_subscription', { ns: 'common' }).toLowerCase()
                }) }}
                </div>
                <b>{{ $t('com_subscription', { ns: 'common' }) }}:</b>
                <br />
                {{ this.mollieSubscriptionDetails[0].description }}
                <br />
                <b>{{ $t('com_amount', { ns: 'common' }) }}:</b>
                <br />
                <div v-if="this.mollieSubscriptionDetails[0].amount">
                    {{ this.mollieSubscriptionDetails[0].amount.value }}
                    {{ this.mollieSubscriptionDetails[0].amount.currency }}
                </div>
                <b>{{ $t('com_interval', { ns: 'common' }) }}:</b>
                <br />
                {{ this.mollieSubscriptionDetails[0].interval }}
                <br />
                <b>{{ $t('com_startdate', { ns: 'common' }) }}:</b>
                <br />
                {{ this.mollieSubscriptionDetails[0].startDate.split('T')[0] }}
                <br />
                <b>{{ $t('com_nextpayment', { ns: 'common' }) }}:</b>
                <br />
                {{
                    this.mollieSubscriptionDetails[0].nextPaymentDate.split(
                        'T'
                    )[0]
                }}
            </div>
            <div v-if="!this.hasActiveSubscription">
                <b-card>
                    {{ $t('com_paymentdetails', { ns: 'common' }) }}:
                    <b-form-group>
                        {{ $t('com_omschrijving', { ns: 'common' }) }}:
                        <b-form-input
                            v-model="startSubscriptionModel.payment.description"
                            placeholder="CheeseIT 0+ subscription"
                            :readonly="true"
                        ></b-form-input>
                        {{ $t('com_amountpermonth', { ns: 'common' }) }} ({{
                            startSubscriptionModel.payment.amount.currency
                        }}):
                        <b-form-input
                            v-model="
                                startSubscriptionModel.payment.amount.value
                            "
                            placeholder="0.00"
                            :readonly="true"
                        ></b-form-input>
                    </b-form-group>
                </b-card>
            </div>
        </b-card>
    </b-modal>
</template>

<!-- MARK: Script
-->
<script>
import { loadItem } from '@/models/DataHelper';
import Helper from '@/models/Helper';
export default {
    name: 'PaymentModal',
    data() {
        return {
            spinnervisible: false,
            sitelijst: this.lijstids,
            selecteddomains: [],
            selectedSiteFormatted: '',
            siteID: 0,
            mollieSubscriptionDetails: [],
            mollieCustomer: null,
            hasActiveSubscription: false,
            knownCustomer: false,
            startSubscriptionModel: {
                customer: {
                    siteID: 0,
                    name: '',
                    email: '',
                    locale: ''
                },
                payment: {
                    customerID: '',
                    description: '',
                    amount: {
                        value: '',
                        currency: 'EUR'
                    }
                }
            },
            missingFields: [],
            lastPayment: {},
            failureMessage: ''
        };
    },
    components: {},
    model: { prop: 'visible', event: 'change' },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        redirectURL() {
            const test = window.location.origin + '/gebruiker/profiel';
            return test;
        }
    },


    async created() {
        const customer = await loadItem(
            'gebruiker/fetchMollieCustomer',
            null,
            this.$t
        );
        this.mollieCustomer = Helper.checkEmptyString(customer.data);
        if (this.mollieCustomer != null) {
            this.knownCustomer = true;

            this.startSubscriptionModel.payment.customerID =
                this.mollieCustomer.id;

            this.startSubscriptionModel.customer = {
                name: this.mollieCustomer.name,
                email: this.mollieCustomer.email,
                locale: this.mollieCustomer.locale
            };
        }

        const version = this.$store.getters['masterdata/getPackageVersion'];
        const pakketnaam = 'CheeseIT ' + version + '+ subscription';
        this.selectedSiteFormatted = pakketnaam;
        this.startSubscriptionModel.payment.description = pakketnaam;
        this.startSubscriptionModel.payment.amount.value =
            await this.getPackagePrice(version);

        if (this.mollieCustomer?.id != undefined) {
            const response = await loadItem(
                'gebruiker/fetchActiveMollieSubscription',
                { customerId: this.mollieCustomer.id },
                this.$t
            );
            this.mollieSubscriptionDetails = response.data ?? [];
        }
        console.log(
            'mollieSubscriptionDetails' +
                JSON.stringify(this.mollieSubscriptionDetails[0])
        );
        if (this.mollieSubscriptionDetails.length == 0) {
            this.mollieSubscriptionDetails = {
                description: 'Geen abonnement',
                amount: { value: 0, currency: 'EUR' },
                interval: 'Geen',
                startDate: 'Geen',
                nextPaymentDate: 'Geen',
                id: 'Geen'
            };
        } else {
            this.hasActiveSubscription = true;
            try {
                const result = await loadItem(
                    'gebruiker/fetchLastPayment',
                    {
                        customerId: this.mollieCustomer.id,
                        subscriptionId: this.mollieSubscriptionDetails[0].id // todo
                    },
                    this.$t
                );
                this.lastPayment = result.data;
                if (
                    this.lastPayment.Details &&
                    this.lastPayment.Details.FailureMessage
                ) {
                    this.failureMessage =
                        this.lastPayment.Details.FailureMessage;
                }
            } catch (error) {
                console.error('Error getting last payment:', error);
            }
        }
    },

    mounted() {},

    methods: {
        setClass() {
            return this.spinnervisible ? 'class="loading-state loading"' : '';
        },
        hide(bvModalEvt) {
            if (this.spinnervisible == false) {
                this.$emit('hide');
            } else bvModalEvt.preventDefault();
        },
        change(visible, bvModalEvt) {
            if (this.spinnervisible == false) {
                this.$emit('change', visible);
            } else bvModalEvt.preventDefault();
        },
        checkFormValidity() {
            const valid = true; // Is depricated from modalUpdateSelected.vue so value is hardcoded. Must be implemented differently.
            return valid;
        },
        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (this.spinnervisible == false) {
                this.handleSubmit();
            }
        },
        async handleSubmit() {
            this.missingFields = [];
            //voeg returnurl toe aan model
            this.startSubscriptionModel.payment.redirectURL = this.redirectURL;
            for (const field in this.startSubscriptionModel.customer) {
                if (this.startSubscriptionModel.customer[field] === '') {
                    this.missingFields.push(field);
                }
            }
            if (this.missingFields.length > 0) {
                return;
            }

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (
                !emailPattern.test(this.startSubscriptionModel.customer.email)
            ) {
                this.missingFields.push('email');
                return;
            }

            if (!this.checkFormValidity()) {
                return;
            }
            let result = null;
            try {
                result = await loadItem(
                    'gebruiker/startMollieSubscription',
                    this.startSubscriptionModel,
                    this.$t
                );
            } catch (error) {
                console.error('Error starting Mollie subscription:', error);
            }

            console.log('result.data');
            console.log(result.data);

            if (this.hasActiveSubscription) {
                this.$emit('hide');
                return;
            }

            const customer = result.data.customer;
            const payment = result.data.payment;

            if (customer) {
                this.knownCustomer = true;
                this.mollieCustomer = customer;
            }

            if (payment) {
                this.redirectToMolliePayment(payment);
            }

            this.spinnervisible = false;
            this.$emit('hide');
        },
        async redirectToMolliePayment(payment) {
            const checkoutUrl = payment._links?.checkout?.href;
            console.log('Redirecting to Mollie checkout URL:', checkoutUrl);
            if (checkoutUrl) {
                window.location.href = checkoutUrl;
            }
            return;
        },
        enableCustomerEdit() {
            this.knownCustomer = false;
        },
        async getPackagePrice(pakket) {
            const result = await loadItem(
                'gebruiker/fetchPriceList',
                null,
                this.$t
            );
            const price = result.data.prices.find(
                (price) => price.name == pakket
            ).Amount;
            return price ? price.toFixed(2) : '150.00';
        }
    }
};
</script>

<!-- MARK: Style
-->
<style scoped>
.loadingstate {
    position: fixed;
    top: 14%;
    left: 47%;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 10px solid #ddd;
    border-top-color: rgb(37, 126, 228);
    animation: loading 1s linear infinite;
    justify-content: center;
}

@keyframes loading {
    to {
        transform: rotate(360deg);
    }
}
</style>
